import {
  VRCORE_GET_TEMPLATES,
  VRCORE_ADD_TEMPLATE,
  VRCORE_EDIT_TEMPLATE,
  VRCORE_REMOVE_TEMPLATE,
  GET_REPORT_TITLES
} from "./types";

const INITIAL_STATE = {
  requesting: false,
  templateList: false,
  uploading: false,
  updating: false,
  removing: false,
  reportTitles: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VRCORE_GET_TEMPLATES.REQUEST: {
      return { ...state, requesting: true, templateList: false };
    }
    case VRCORE_GET_TEMPLATES.FAIL: {
      return { ...state, requesting: false, templateList: false };
    }
    case VRCORE_GET_TEMPLATES.SUCCESS: {
      return {
        ...state,
        requesting: false,
        templateList: action.payload
      };
    }
    case VRCORE_ADD_TEMPLATE.REQUEST: {
      return { ...state, requesting: true, uploading: true };
    }
    case VRCORE_ADD_TEMPLATE.SUCCESS: {
      return { ...state, requesting: false, uploading: false };
    }
    case VRCORE_ADD_TEMPLATE.FAIL: {
      return { ...state, requesting: false, uploading: false };
    }
    case VRCORE_EDIT_TEMPLATE.REQUEST: {
      return { ...state, requesting: true, updating: true };
    }
    case VRCORE_EDIT_TEMPLATE.SUCCESS: {
      return { ...state, requesting: false, updating: false };
    }
    case VRCORE_EDIT_TEMPLATE.FAIL: {
      return { ...state, requesting: false, updating: false };
    }
    case VRCORE_REMOVE_TEMPLATE.REQUEST: {
      return { ...state, requesting: true, removing: true };
    }
    case VRCORE_REMOVE_TEMPLATE.SUCCESS: {
      return { ...state, requesting: false, removing: false };
    }
    case VRCORE_REMOVE_TEMPLATE.FAIL: {
      return { ...state, requesting: false, removing: false };
    }
    case GET_REPORT_TITLES.REQUEST: {
      return { ...state, requesting: true, reportTitles: false };
    }
    case GET_REPORT_TITLES.SUCCESS: {
        return {
            ...state,
            requesting: false,
            reportTitles: action.payload
        };
    }
    case GET_REPORT_TITLES.FAIL: {
        return { ...state, requesting: false, reportTitles: false };
    }
    default: {
      return state;
    }
  }
};
